module.exports = __webpack_public_path__ + "img/circle-plus.c8b85cb9.svg";